// extracted by mini-css-extract-plugin
module.exports = {"loader":"SnakeLoader_loader__61WBY","spin":"SnakeLoader_spin__0a_xm"};